import { expose } from "comlink";
import { pdf } from "@react-pdf/renderer";
import PlayPDF from "@src/playcreator/pdf_components/PlayPDF.jsx";
import PlaybookPDF from "@src/playcreator/pdf_components/PlaybookPDF.jsx";
import RotationPDF from "@src/rotationEditor/pdf_components/RotationPDF.jsx";
import { captureException } from "@sentry/core";
import PublicSansRegular from "@src/fonts/Public_Sans/PublicSans-Regular.ttf";
import PublicSansBold from "@src/fonts/Public_Sans/PublicSans-Bold.ttf";
import PublicSansItalic from "@src/fonts/Public_Sans/PublicSans-Italic.ttf";
import PublicSansBoldItalic from "@src/fonts/Public_Sans/PublicSans-BoldItalic.ttf";
import RobotoRegular from "@src/fonts/Roboto/Roboto-Regular.ttf";
import RobotoBold from "@src/fonts/Roboto/Roboto-Bold.ttf";
import ArialBold from "@src/fonts/Arial/Arial_Bold.ttf";
import NotoSansRegular from "@src/fonts/Noto_Sans/static/NotoSans-Regular.ttf";
import NotoSansBold from "@src/fonts/Noto_Sans/static/NotoSans-Bold.ttf";
import NotoSansItalic from "@src/fonts/Noto_Sans/static/NotoSans-Italic.ttf";
import NotoSansBoldItalic from "@src/fonts/Noto_Sans/static/NotoSans-BoldItalic.ttf";
import NotoSansArabicRegular from "@src/fonts/Noto_Sans_Arabic/static/NotoSansArabic-Regular.ttf";
import NotoSansArabicBold from "@src/fonts/Noto_Sans_Arabic/static/NotoSansArabic-Bold.ttf";
import { StyleSheet, Font } from "@react-pdf/renderer";

/*
Font.register({
  family: "Noto Sans JP",
  fonts: [
    {
      src: NotoSansJPRegular,
    },
    {
      src: NotoSansJPBold,
      fontWeight: "bold",
    },
    {
      src: NotoSansJPRegular,
      fontStyle: "italic",
    },
    {
      src: NotoSansJPBold,
      fontStyle: "italic",
      fontWeight: "bold",
    },
  ],
});

Font.register({
  family: "Noto Sans KR",
  fonts: [
    {
      src: NotoSansKRRegular,
    },
    {
      src: NotoSansKRBold,
      fontWeight: "bold",
    },
    {
      src: NotoSansKRRegular,
      fontStyle: "italic",
    },
    {
      src: NotoSansKRBold,
      fontStyle: "italic",
      fontWeight: "bold",
    },
  ],
}); */

Font.register({
  family: "Public Sans",
  fonts: [
    {
      src: PublicSansRegular,
    },
    {
      src: PublicSansBold,
      fontWeight: "bold",
    },
    {
      src: PublicSansItalic,
      fontStyle: "italic",
    },
    {
      src: PublicSansBoldItalic,
      fontStyle: "italic",
      fontWeight: "bold",
    },
  ],
});

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: RobotoRegular,
    },
    {
      src: RobotoBold,
      fontWeight: "bold",
    },
  ],
});

Font.register({
  family: "Arial",
  fonts: [
    {
      src: ArialBold,
      fontWeight: "bold",
    }, // font-style: normal, font-weight: normal
  ],
});

Font.register({
  family: "Noto Sans",
  fonts: [
    {
      src: NotoSansRegular,
    },
    {
      src: NotoSansBold,
      fontWeight: "bold",
    },
    {
      src: NotoSansItalic,
      fontStyle: "italic",
    },
    {
      src: NotoSansBoldItalic,
      fontStyle: "italic",
      fontWeight: "bold",
    },
  ],
});

Font.register({
  family: "Noto Sans Arabic",
  fonts: [
    {
      src: NotoSansArabicRegular,
    },
    {
      src: NotoSansArabicBold,
      fontWeight: "bold",
    },
    {
      src: NotoSansArabicRegular,
      fontStyle: "italic",
    },
    {
      src: NotoSansArabicBold,
      fontStyle: "italic",
      fontWeight: "bold",
    },
  ],
});

const renderPDFPlay = async (props) => {
  return pdf(<PlayPDF {...props} />).toBlob();
};

const renderPDFPlaybook = async ({ data }) => {
  const tocData = [];
  await pdf(<PlaybookPDF tocData={tocData} {...data} />).toBlob();
  return pdf(<PlaybookPDF tocData={tocData} {...data} />).toBlob();
};

const renderRotationPDF = async (props) => {
  return pdf(<RotationPDF {...props} />).toBlob();
};

let log = (error) => {
  captureException(error, {
    tags: {
      pdf: true,
    },
  });
};

const renderPlay = async (props) => {
  try {
    let blob = await renderPDFPlay(props);
    return URL.createObjectURL(blob);
  } catch (error) {
    log(error);
    throw error;
  }
};

const renderPlaybook = async ({ data }) => {
  try {
    return URL.createObjectURL(await renderPDFPlaybook({ data }));
  } catch (error) {
    log(error);
    throw error;
  }
};

const renderRotation = async (props) => {
  try {
    let blob = await renderRotationPDF(props);
    return URL.createObjectURL(blob);
  } catch (error) {
    log(error);
    throw error;
  }
};

const onProgress = (cb = console.info) => (log = cb);

expose({ renderPlay, renderPlaybook, renderRotation, onProgress });
